import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import '../pages/SitePage.css';
import { Navigate } from 'react-router-dom';

interface InfoPanelProps {
  message: string;
  item: string;
  onClick?: Function;
}

interface InfoPanelState {
  hide: boolean;
}

class InfoPanel extends React.Component<InfoPanelProps, InfoPanelState> {
  static lastInvite:any = null;

  constructor(props: InfoPanelProps) {
    super(props);
    this.state = {
      hide: false,
    }
  }

  componentDidMount(): void {
    let s = localStorage.getItem(this.props.item);
    this.setState({hide: (s != null)});
  }

  onHide(e:any = null) {
    if(e)
      e.stopPropagation();
    localStorage.setItem(this.props.item, '1');
    this.setState({hide: true});
  }

  onNavigate() {
    this.onHide();
    this.props.onClick?.();
  }

  render() {
    if(this.state.hide)
      return null;

    return (
      <div 
        className="site-page-notification-panel" 
        style={{alignItems: 'center', columnGap: '5px',  display: 'grid', gridTemplateColumns: '1fr min-content', cursor: 'pointer'}}
        onClick={()=>this.onNavigate()}
      >
        <span>
          {this.props.message}
        </span>
        <div style={{cursor: 'pointer'}} onClick={(e)=>this.onHide(e)}>
          <BsFillXCircleFill style={{display: 'block', fontSize: '1.1em', marginLeft: '5px'}} />
        </div>
      </div>
    )
  }
}

export default InfoPanel;